import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ListingComponent} from './app.component';
import {ListingService} from '../../services/listing.service';
import {CompanyService} from '../../services/company.service';
import {TicketsService} from '../../services/tickets.service';
import {OdneyComponent} from './odney/app.component';
import {IframeButtonComponent} from './iframe-button/app.component';
import {ProductTicketsComponent} from './product-tickets/app.component';
import {MaterialModule} from '../../../material.module';
import {ProductProductsComponent} from './product-products/product-products.component';
import {CarouselModule} from '../../component/carousel/module';
import { SharedModule } from '../shared/module';
import {BambuserPlaylistComponent} from '../../component/bambuser-playlist/app.component';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    CarouselModule,
    SharedModule,
    BambuserPlaylistComponent,
  ],
  declarations: [
    ListingComponent,
    ProductTicketsComponent,
    OdneyComponent,
    IframeButtonComponent,
    ProductProductsComponent,
  ],
  providers: [ListingService, CompanyService, TicketsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ListingModule {}
